module.exports = __webpack_public_path__ + "static/media/user_icon_navbar.f7b64a1c.svg";